import Entity from './Entity';

export default class BackgroundTimeZone implements Entity {
  constructor(public id: number, public name: string) {}
}
